import { FixedContainer } from '@calendly/ui/components/fixed-container';
import classNames from 'classnames';
import { useEffect, useState, useSyncExternalStore } from 'react';
import { CONFETTI_FRAME_COUNT, confettiPlaybackFrames } from './icons/confetti/confetti_frames';
const CONFETTI_FRAME_INTERVAL_MS = 80;
function subscribePrefersReducedMotion(callback) {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  mq.addEventListener('change', callback);
  return () => mq.removeEventListener('change', callback);
}
function getPrefersReducedMotionSnapshot() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function getPrefersReducedMotionServerSnapshot() {
  return false;
}
function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribePrefersReducedMotion, getPrefersReducedMotionSnapshot, getPrefersReducedMotionServerSnapshot);
}

/** Full-viewport layer; `position: fixed` comes from {@link FixedContainer}. */
const viewportLayerCss = "v1g5d035";
const frameImgCss = "f3l1zrb";
export const AlmostThereConfetti = () => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [frameIndex, setFrameIndex] = useState(0);
  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }
    let current = 0;
    const id = window.setInterval(() => {
      if (current >= CONFETTI_FRAME_COUNT - 1) {
        window.clearInterval(id);
        return;
      }
      current += 1;
      setFrameIndex(current);
    }, CONFETTI_FRAME_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [prefersReducedMotion]);
  if (prefersReducedMotion || typeof document === 'undefined') {
    return null;
  }
  return <FixedContainer className={viewportLayerCss} data-testid="ai-assistant-almost-there-confetti" aria-hidden>
      {confettiPlaybackFrames.map(({
      id,
      src
    }, index) => <img key={id} src={src} alt="" draggable={false} className={classNames(frameImgCss, {
      active: index === frameIndex
    })} data-active={index === frameIndex ? 'true' : undefined} />)}
    </FixedContainer>;
};

require("./almost_there_confetti.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./almost_there_confetti.js");